export default __webpack_public_path__ + "static/ribbon_bg-3fcca315ce81620d8accbf02918aa3a9.png";